import React from 'react';
import styled, { css } from 'styled-components';

import Button from '@/components/Button';
import { media } from '@/utils/mixin';
import {
  getCreditProductsThunk,
  selectCreditPeriod,
  selectCreditPrepayment,
  selectCreditProductsStatus,
} from '@/store/reducers/detailed-car';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import Loader from '@/components/Loader';
import { colors } from '@/constants/theme';

import { CalcButtonProps } from './types';

function CalcButton({ creditType, carId }: CalcButtonProps) {
  const dispatch = useTypedDispatch();
  const creditPrepayment = useTypedSelector(selectCreditPrepayment);
  const creditPeriod = useTypedSelector(selectCreditPeriod);
  const creditProductStatus = useTypedSelector(selectCreditProductsStatus);

  const isCreditProductStatusSuccess = creditProductStatus === 'SUCCESS';

  const handleCalcCreditProducts = async () => {
    try {
      await dispatch(
        getCreditProductsThunk({
          type: creditType === 'credit' ? 'CREDIT' : 'LEASING',
          car: String(carId),
          prepayment: String(creditPrepayment),
          period: String(creditPeriod),
        })
      );
    } catch (error) {
      console.log('error = ', error);
    }
  };

  return (
    <Component>
      <StyledButton
        variant="contained"
        onClick={handleCalcCreditProducts}
        disabled={!isCreditProductStatusSuccess}
      >
        {isCreditProductStatusSuccess ? (
          'Рассчитать'
        ) : (
          <Loader color={colors.white} />
        )}
      </StyledButton>
    </Component>
  );
}

export default CalcButton;

const Component = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;

  ${media.tablet(css`
    margin-top: 25px;
  `)}
`;

const StyledButton = styled(Button)`
  max-width: 180px;

  ${media.mobile(css`
    max-width: none;
  `)}
`;
